export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8290.8833b699.jpg";